/**
 * Mock data pre číselníky (dictionary)
 */

import { municipalityIds, countryIds } from "./officials";

// Typy funkcií
export const functionTypes = [
  { id: "ft-001", name: "člen vlády", code: "CLEN_VLADY" },
  { id: "ft-002", name: "poslanec", code: "POSLANEC" },
  { id: "ft-003", name: "senátor", code: "SENATOR" },
  { id: "ft-004", name: "náměstek člena vlády", code: "NAMESTEK_CLENA_VLADY" },
  {
    id: "ft-005",
    name: "vedoucí ústředního správního úřadu",
    code: "VEDOUCI_USU",
  },
  { id: "ft-006", name: "člen rady kraje", code: "CLEN_RADY_KRAJE" },
  { id: "ft-007", name: "člen rady obce", code: "CLEN_RADY_OBCE" },
  { id: "ft-008", name: "starosta obce", code: "STAROSTA" },
  { id: "ft-009", name: "hejtman", code: "HEJTMAN" },
  { id: "ft-010", name: "primátor", code: "PRIMATOR" },
  { id: "ft-011", name: "ředitel odboru", code: "REDITEL_ODBORU" },
  { id: "ft-012", name: "soudce", code: "SOUDCE" },
  { id: "ft-013", name: "státní zástupce", code: "STATNI_ZASTUPCE" },
];

// Stavy oznámení
export const statementStates = [
  { id: "ss-001", name: "nové", code: "NEW" },
  { id: "ss-002", name: "schválené", code: "ACCEPT" },
  { id: "ss-003", name: "neúplné", code: "INCOMPLETE" },
  { id: "ss-004", name: "zamítnuté", code: "REJECT" },
];

// Typy oznámení
export const statementTypes = [
  { id: "st-001", name: "vstupní", code: "INGOING" },
  { id: "st-002", name: "průběžné", code: "ONGOING" },
  { id: "st-003", name: "výstupní", code: "OUTGOING" },
  { id: "st-004", name: "podle bodu 3", code: "POINT3" },
];

// Viditelnost oznámení
export const visibilityTypes = [
  { id: "vt-001", name: "veřejné", code: "PUBLIC" },
  { id: "vt-002", name: "na žádost", code: "REQUEST" },
  { id: "vt-003", name: "tajné", code: "SECRET" },
];

// Stavy žiadostí
export const requestStates = [
  { id: "rs-001", name: "nová", code: "NEW" },
  { id: "rs-002", name: "schválená", code: "ACCEPT" },
  { id: "rs-003", name: "zamítnutá", code: "REJECT" },
];

// Stavy podnetov
export const initiativeStates = [
  { id: "is-001", name: "nový", code: "NEW" },
  { id: "is-002", name: "v šetření", code: "INVESTIGATION" },
  { id: "is-003", name: "uzavřený", code: "CLOSED" },
];

// Výsledky podnetov
export const initiativeResults = [
  { id: "ir-001", name: "důvodný", code: "JUSTIFIED" },
  { id: "ir-002", name: "nedůvodný", code: "UNJUSTIFIED" },
  { id: "ir-003", name: "částečně důvodný", code: "PARTIAL" },
];

// Druhy vlastníctva
export const ownershipTypes = [
  { id: "ot-001", name: "výlučné", code: "EXCLUSIVE" },
  { id: "ot-002", name: "spoluvlastnictví", code: "SHARED" },
  { id: "ot-003", name: "SJM", code: "SJM" },
];

// Spôsoby nadobudnutia
export const acquisitionMethods = [
  { id: "am-001", name: "koupě", code: "PURCHASE" },
  { id: "am-002", name: "dědictví", code: "INHERITANCE" },
  { id: "am-003", name: "dar", code: "GIFT" },
  { id: "am-004", name: "privatizace", code: "PRIVATIZATION" },
  { id: "am-005", name: "restituce", code: "RESTITUTION" },
  { id: "am-006", name: "výstavba", code: "CONSTRUCTION" },
];

// Typy cenných papierov
export const securityTypes = [
  { id: "sec-001", name: "akcie", code: "SHARES" },
  { id: "sec-002", name: "dluhopisy", code: "BONDS" },
  { id: "sec-003", name: "podílové listy", code: "FUND_UNITS" },
  { id: "sec-004", name: "směnky", code: "BILLS" },
];

// Typy záväzkov
export const liabilityTypes = [
  { id: "lt-001", name: "hypotéka", code: "MORTGAGE" },
  { id: "lt-002", name: "spotřebitelský úvěr", code: "CONSUMER_LOAN" },
  { id: "lt-003", name: "půjčka", code: "LOAN" },
  { id: "lt-004", name: "leasing", code: "LEASING" },
];

// Štáty
export const countries = [
  { id: countryIds.czechRepublic, name: "Česká republika", code: "CZ" },
  { id: countryIds.slovakia, name: "Slovenská republika", code: "SK" },
  { id: "c-003", name: "Německo", code: "DE" },
  { id: "c-004", name: "Rakousko", code: "AT" },
  { id: "c-005", name: "Polsko", code: "PL" },
];

// Obce (zjednodušený zoznam)
export const municipalities = [
  {
    id: municipalityIds.praha,
    name: "Praha",
    zip: "11000",
    countryId: countryIds.czechRepublic,
  },
  {
    id: municipalityIds.brno,
    name: "Brno",
    zip: "60200",
    countryId: countryIds.czechRepublic,
  },
  {
    id: municipalityIds.ostrava,
    name: "Ostrava",
    zip: "70200",
    countryId: countryIds.czechRepublic,
  },
  {
    id: municipalityIds.plzen,
    name: "Plzeň",
    zip: "30100",
    countryId: countryIds.czechRepublic,
  },
  {
    id: "m-005",
    name: "Olomouc",
    zip: "77900",
    countryId: countryIds.czechRepublic,
  },
  {
    id: "m-006",
    name: "Liberec",
    zip: "46001",
    countryId: countryIds.czechRepublic,
  },
  {
    id: "m-007",
    name: "Hradec Králové",
    zip: "50002",
    countryId: countryIds.czechRepublic,
  },
  {
    id: "m-008",
    name: "České Budějovice",
    zip: "37001",
    countryId: countryIds.czechRepublic,
  },
  {
    id: "m-009",
    name: "Pardubice",
    zip: "53002",
    countryId: countryIds.czechRepublic,
  },
  {
    id: "m-010",
    name: "Zlín",
    zip: "76001",
    countryId: countryIds.czechRepublic,
  },
];

// Typy OVM
export const ovmTypes = [
  { id: "ovmt-001", name: "ministerstvo", code: "MINISTRY" },
  { id: "ovmt-002", name: "parlament", code: "PARLIAMENT" },
  { id: "ovmt-003", name: "kraj", code: "REGION" },
  { id: "ovmt-004", name: "obec", code: "MUNICIPALITY" },
  { id: "ovmt-005", name: "statutární město", code: "STATUTORY_CITY" },
];

// Role používateľov
export const userRoles = [
  {
    id: "role-001",
    name: "admin",
    code: "ADMIN",
    description: "Administrátor systému",
  },
  {
    id: "role-002",
    name: "evidenční orgán",
    code: "EO",
    description: "Evidenční orgán OVM",
  },
  {
    id: "role-003",
    name: "tajemník",
    code: "TAJEMNIK",
    description: "Tajemník OVM",
  },
  {
    id: "role-004",
    name: "veřejný funkcionář",
    code: "VF",
    description: "Veřejný funkcionář",
  },
  {
    id: "role-005",
    name: "veřejnost",
    code: "PUBLIC",
    description: "Veřejnost",
  },
];

// Roky pre výber
export const years = [
  { id: "y-2025", name: "2025", value: 2025 },
  { id: "y-2024", name: "2024", value: 2024 },
  { id: "y-2023", name: "2023", value: 2023 },
  { id: "y-2022", name: "2022", value: 2022 },
  { id: "y-2021", name: "2021", value: 2021 },
  { id: "y-2020", name: "2020", value: 2020 },
];

// Export všetkých číselníkov
export const dictionaries = {
  functionTypes,
  statementStates,
  statementTypes,
  visibilityTypes,
  requestStates,
  initiativeStates,
  initiativeResults,
  ownershipTypes,
  acquisitionMethods,
  securityTypes,
  liabilityTypes,
  countries,
  municipalities,
  ovmTypes,
  userRoles,
  years,
};

export default dictionaries;
